<template>
  <TransparentCard container-class="flex-row">
    <div class="left">
      <BaseImage :src="iconSrc" :alt="iconAlt" />

      <p>{{ value }}</p>
    </div>
    <div class="right">
      <p>{{ $_translations.value[description] }}</p>
    </div>
  </TransparentCard>
</template>

<script setup>
import TransparentCard from '@/components/card/TransparentCard.vue';
import BaseImage from '@/components/image/BaseImage.vue';

defineProps({
  value: {
    type: [String, Number],
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  iconSrc: {
    type: String,
    default: '',
  },
  iconAlt: {
    type: String,
    default: '',
  },
});
</script>
